import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SorterModel } from 'Modules'

export type SortingState = {
	sorter: SorterModel | null
}

const initialState: SortingState = {
	sorter: null,
}

export namespace SortingNS {
	export type ClearValues = PayloadAction
	export type SetSorting = PayloadAction<SorterModel>
}

export const sortingSlice = createSlice({
	name: 'sorting',
	initialState,
	reducers: {
		clearValues: (state, action: SortingNS.ClearValues) => {
			state.sorter = null
		},
		setSorting: (state, action: SortingNS.SetSorting) => {
			state.sorter = action.payload
		},
	},
})
